import railsFactory from '../../../shared/ducks/rails_factory.js'

let rails = railsFactory("event_attendee_form", {})

export default rails.default
export const loadMetaData    = rails.loadMetaData
export const refreshMetaData = rails.refreshMetaData
export const apiEndpoint     = rails.apiEndpoint